// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__22vzR","info":"Menu_info__3ejjy"};